import { NAVY, NAVY_BG, YELLOW } from 'const';
import { createContext } from 'react';
import { ContextType } from 'type';

export const contextDefaultValue: ContextType = {
  timeline: [
    {
      date: '1 ม.ค. 64',
      activities: [
        {
          time: '6.00',
          place: '*คลิกเพื่อแก้ไขข้อความ',
        },
      ],
    },
  ],
  setTimeline: () => undefined,
  mainText: 'ผู้ป่วยชาย อายุ 42.195 ปี*',
  setMainText: () => undefined,
  suppText: 'อาชีพ พนักงานบริษัท*',
  setSuppText: () => undefined,
  caption: 'รายที่ 999',
  setCaption: () => undefined,
  gender: 'male',
  setGender: () => undefined,
  profile: '',
  setProfile: () => undefined,
  setDate: () => undefined,
  setTime: () => undefined,
  setPlace: () => undefined,
  addDate: () => undefined,
  removeDate: () => undefined,
  addActivity: () => undefined,
  colors: [NAVY_BG, NAVY, YELLOW, '#FFFFFF'],
  setColors: () => undefined,
};

const Context = createContext<ContextType>(contextDefaultValue);

export const ContextProvider = Context.Provider;
export const ContextConsumer = Context.Consumer;
export default Context;
